export const ArrayOf = () => {}
export const OneOf = () => {}
export const Optional = () => {}
export const toObjectModel = () => {}
export const formatErrors = () => []
export const validateIfIsModel = () => {}
export const isModelNoLog = () => () => true
export const isModel = () => () => true
export const throwIfNotModel = () => x => x
export const rejectIfNotModel = () => x => x
